<template>
	<div class="clients-search">
		<template v-if="selectedClient.id === null">
			<div class="form-group">
				<input type="text" class="form-control form-control-sm" v-model="search" placeholder="Select Client" />
			</div>
			<div class="search-results-container position-relative">
				<div class="search-results position-absolute bg-white rounded shadow-sm" style="z-index:999;min-width: 500px;">
					<template v-if="!loading">
						<template v-if="clients.length > 0">
							<template v-for="client in clients">
								<div :key="client.id" @click="setClient(client)" class="search-item ps-2 pe-2 py-1 d-flex">
									<span class="me-2 w-50" style="font-size: 12px;">{{ client.name }}</span>
									<span class="me-2 w-25" style="font-size: 12px;">{{ client.county }}</span>
									<span class="w-25 text-end pe-2" style="font-size: 12px;">{{ client.state }}</span>
								</div>
							</template>
						</template>
						<template v-if="clients.length === 0 && search.length > 3">
							<span class="me-2 ms-2">Client not found!</span>
						</template>
					</template>
					<template v-else>
						<div class="d-flex justify-content-center p-2">
							<font-awesome-icon :icon="['fas', 'spinner']" class="me-1 fa-spin" />
						</div>
					</template>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="form-group">
				<div class="d-flex justify-content-center align-items-center">
					<h6 class="p-0 m-0">{{ selectedClient.name }}</h6>
					<button @click="changeClient()" class="btn text-danger p-0"><font-awesome-icon :icon="['fas', 'times']" /></button>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import restApi from '../../api/index'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'ClientSelector',
	props: ['excludeClients', 'selected'],
	data() {
		return {
			loading: false,
			clients: [],
			search: '',
			clientId: null,
			selectedClient: {
				id: null,
				name: '',
			},
		}
	},
	created() {
		if (this.selected !== null) {
			this.selectedClient = {
				id: this.selected.id,
				name: this.selected.name,
			}
		} else {
			this.selectedClient = {
				id: null,
				name: '',
			}
		}
	},
	computed: {
		...mapState(['storageUrl']),
	},
	methods: {
		getClients() {
			this.loading = true
			this.params = {
				search: this.search,
			}
			restApi
				.get(`/clients/search`, { params: this.params })
				.then(({ data }) => {
					this.clients = data
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		setClient(client) {
			this.selectedClient.id = client.id
			this.selectedClient.name = client.name
			this.clients = []
			this.search = ''
			this.$emit('setClient', client)
		},
		changeClient() {
			this.selectedClient = {
				id: null,
				name: '',
			}
			this.$emit('setClient', null)
		},
	},
	watch: {
		search: function() {
			if (this.search.length >= 2) {
				if (!this.loading) {
					this.getClients()
				}
			} else {
				this.clients = []
			}
		},
	},
}
</script>

<style lang="scss">
.search-results-container {
	.search-results {
		width: 100%;
		.search-item {
			cursor: pointer;
			&:hover {
				background-color: whitesmoke;
				border-radius: 0.5rem;
			}
		}
	}
}
</style>
